import * as moment from 'moment';
import { TDrawModel } from '../../draw.model';
import { TTimelieWrapper } from './draw.tasks';
import { DRAW_MODEL_UTILS } from '../utils';
import * as _ from 'lodash';
import { TDate } from '@monorepo/types';

const addDefs = (drawModel: TDrawModel, body: ReturnType<typeof drawBody>) => {
  return body.selectAll('defs').data([drawModel]).join('defs').html(`
    <!-- Arrow Head -->
    <marker id="${drawModel.defsIds.arrow}" viewBox="0 -5 10 10" refX=8 refY=0 orient="auto">
      <path d="M0,-5L10,0L0,5" fill="#0F31A9" />
    </marker>
  
    <!-- Pattern Checkered -->
    <pattern id='${drawModel.defsIds.checkered}' patternUnits='userSpaceOnUse' width='4' height='4'>
      <rect width="2" height="2" fill="#fff"></rect>
      <rect x="2" y="2" width="2" height="2" fill="#fff"></rect>
      <rect width="2" height="2" fill="#ececec"></rect>
      <rect x="2" y="2" width="2" height="2" fill="#ececec"></rect>
    </pattern>
  
    <!-- Mask + Pattern Zig Zag -->
    <pattern id="${drawModel.defsIds['pattern-zig-zag']}" x="0" y="1" patternUnits="userSpaceOnUse" width="20" height="20"> 
        <rect width="100%" height="100%" fill="black"></rect>
        <g fill="white">
          <path class="left" d="M0,0 l10,10 v8 l-10,-10 z" />
          <path class="right" d="M20,0 l-10,10 v8 l10,-10" />
        </g>
    </pattern>
  
    <mask id="${drawModel.defsIds['mask-zig-zag']}">
    // width set assuming max range as 100 months
      <rect width="10000%" height="20" fill="url(#${drawModel.defsIds['pattern-zig-zag']})" />
    </mask>
    
    <!-- Mask + Pattern Mesh -->
    <pattern id='${drawModel.defsIds['pattern-mesh']}' patternUnits='userSpaceOnUse' width='4' height='4'>
      <rect x='0' y='0' width='100%' height='100%' fill='white'/>
      <g fill="black">
        <rect x="0" width="2" height="2" fill="black" rx=2 ry=2></rect>
        <rect x="2" y="2" width="2" height="2" fill="black" rx=2 ry=2></rect>
        <rect x="-2" y="2" width="2" height="2" fill="black" rx=2 ry=2></rect>
      </g> 
    </pattern>
    <mask id="${drawModel.defsIds['mask-mesh']}" width="40" height="40" >
      <rect width="110%" height="100%" fill="url(#${drawModel.defsIds['pattern-mesh']})" />
    </mask>

    <pattern id="${drawModel.defsIds['pattern-diagonal-stripes']}" width="10" height="10" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
      <rect width="2" height="10" fill="black" />
    </pattern>
  `);
};

const addStripRowSeparator = (drawModel: TDrawModel, background: ReturnType<typeof drawBody>) => {
  const lineMaker = background
    .selectAll('.entity-separator')
    .data([drawModel])
    .join((enter) => enter.append('g'))
    .classed('entity-separator', true);

  lineMaker
    .selectAll('.separator-line')
    .data(_.flatten(drawModel.timelineModel.entities.map((v) => v.entities)))
    .join('line')
    .classed('separator-line', true)
    .style('stroke', '#F1F6F8')
    .style('stroke-width', 3)
    .style('stroke-opacity', 0.5)
    .attr('x1', 0)
    .attr('y1', (_, i) => drawModel.layout.entityHeight * (i + 1))
    .attr('x2', drawModel.width)
    .attr('y2', (_, i) => drawModel.layout.entityHeight * (i + 1));
};

export const drawBody = (drawModel: TDrawModel, timelineWrapper: TTimelieWrapper) => {
  const body = timelineWrapper
    .selectAll('.body')
    .data([drawModel])
    .join('svg')
    .classed('body', true)
    .attr('width', drawModel.width + 'px')
    .attr(
      'height',
      drawModel.timelineModel.comptedEntities.totalEntities * drawModel.layout.entityHeight +
        drawModel.layout.headerHeight +
        'px',
    )
    .style('padding-top', drawModel.layout.headerHeight + 'px');

  addDefs(drawModel, body);
  addStripRowSeparator(drawModel, body);
  return body;
};
